export const locale = {
  lang: 'en',
  data: {
    NEW_CLIENT: 'New client',
    EDIT_CLIENT: 'Edit client',
    BUSINESS_NAME: 'Business name',
    COUNTRY: 'Country',
    TAX_CODE: 'Tax code',
    CERTIFIED_EMAIL: 'Certified email',
    CONTACT: {
      CONTACT_DATA: 'Contact data',
      LAST_NAME: 'Last name',
      FIRST_NAME: 'First name',
      EMAIL: 'Email',
      PHONE: 'Phone',
    },
    OTHER: {
      OTHER_DATA: 'Payment experiences',
      IS_NEW: 'I have no previous payment experience',
      AVERAGE_INVOICE_AMOUNT: 'Average invoice amount',
      YEARLY_BILLED_AMOUNT: 'Yearly billed amount',
      EXISTING_INVOICE_TOTAL_AMOUNT: 'Existing invoice total amount',
      PAYMENT_METHOD: 'Payment method',
      PM: {
        TRANSFER: 'Transfer',
        BANK_RECEIPT: 'Bank receipt',
      },
      PAYMENT_TERMS: 'Payment terms',
      PT: {
        '30GG': '30 days',
        '60GG': '60 days',
        '90GG': '90 days',
        '120GG': '120 days',
        '150GG': '150 days',
        '180GG': '180 days',
        OTHER: 'Other',
      },
      AVERAGE_PAYMENT_DELAY: 'Average payment delay',
    },
    BTN: {
      CANCEL: 'Cancel',
      ADD: 'Add',
      EDIT: 'Edit',
    },
    ERROR: {
      NOT_SAVE: 'Error: client not saved... Retry!',
      REQUIRED: 'Field required',
      EMAIL: 'Please enter a valid email address',
      TAX_CODE: {
        USED: 'Tax code already used',
        INVALID: 'Tax code invalid',
        FORMAT: 'Wrong format',
      },
      PHONE: 'Please enter a valid phone number',
    },
  },
};
